module.exports = __webpack_public_path__ + "static/forecast/weather/nightlightrain-036be38ef2f23aec6ebf965a7eb570c0.svg";